import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

import { metaDataContent } from '../../../../../../locale/meta-data/meta-data.content.en'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { BreadcrumbLink } from '../../../../../shared/interfaces/breadcrumb-link.interface'
import { Filter } from '../../../../../shared/interfaces/filter.interface'
import { Paginator } from '../../../../../shared/interfaces/paginator.interface'
import { BreadcrumbService } from '../../../../../shared/services/breadcrumb.service'
import { FlashMessageService } from '../../../../../shared/services/flash-message.service'
import { MetaService } from '../../../../../shared/services/meta.service'
import { ToolsCatalogueListComponent } from '../../../base-components/tools-catalogue-list.component'
import { ToolUseCase } from '../../../interfaces/tool-use-case.interface'
import { Tool } from '../../../interfaces/tool.interface'
import { ToolUseCaseService } from '../../../services/tool-use-case.service'
import { ToolService } from '../../../services/tool.service'
import { useCaseFilterGroups } from './tool-use-case-filter-groups.content'

@Component({
  selector: 'app-tool-use-case-list',
  templateUrl: './tool-use-case-list.component.html',
  styleUrls: ['./tool-use-case-list.component.scss']
})
export class ToolUseCaseListComponent
  extends ToolsCatalogueListComponent
  implements OnInit
{
  toolUseCases: Paginator<ToolUseCase>
  currentPath = '/catalogue/tool-use-cases'
  loading: boolean
  breadcrumbLinks: BreadcrumbLink[]

  filterGroups: {
    name?: string
    filters: Filter[]
    isHidden?: boolean
  }[] = useCaseFilterGroups

  resourceSlug = ResourceSlug.ToolUseCases

  constructor(
    private toolUseCaseService: ToolUseCaseService,
    private toolService: ToolService,
    private breadcrumbService: BreadcrumbService,
    private activatedRoute: ActivatedRoute,
    private flashMessageService: FlashMessageService,
    router: Router,
    metaService: MetaService
  ) {
    super(router)
    metaService.setTags(metaDataContent.toolCatalogUseCaseList)
  }

  async ngOnInit(): Promise<void> {
    // Add fetch function from toolService to "toolId" filter.
    const toolFilter: Filter = this.filterGroups
      .find((fG) => fG.filters.find((f) => f.queryParam === 'toolIds'))
      .filters.find((f) => f.queryParam === 'toolIds')

    toolFilter.searchFunction = (terms: string) =>
      this.toolService.listUnpaginated({ terms }).then((res: Tool[]) =>
        res.map((tool: Tool) => ({
          id: tool.id,
          label: tool.name
        }))
      )
    toolFilter.initialValueFetchFunction = (toolIds: number[]) =>
      this.toolService.listUnpaginated({ toolIds }).then((res: Tool[]) =>
        res.map((tool: Tool) => ({
          id: tool.id,
          label: tool.name
        }))
      )

    this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
      this.loading = true
      this.queryParams = queryParams
      this.toolUseCases = null

      this.toolUseCaseService
        .listPaginated(queryParams)
        .then((useCaseRes: Paginator<ToolUseCase>) => {
          this.loading = false
          this.toolUseCases = useCaseRes
        })
        .catch(() => {
          this.loading = false
          this.flashMessageService.error(
            'Something went wrong. Please try again later.'
          )
        })
    })

    this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
      'toolCatalog',
      [
        {
          label: 'List of tool use cases'
        }
      ]
    )
  }
}
